import { getCustomTrackingId } from '../../analytics-library/getCustomTrackingId/getCustomTrackingId';
import { Site } from '../../core/modules/sites/Site';
import { SeasonalEventMerchant } from '../../core/types/SeasonalEvent';
import { EventBattle } from '../../types/Battle';

export const getSeasonalMerchantCustomTrackingId = async (
  site: Site,
  merchant: SeasonalEventMerchant,
  area: string,
  battle: EventBattle | null,
  articleType?: string,
  articleCategory?: string,
): Promise<string> => {
  return getCustomTrackingId({
    site,
    area,
    articleType,
    articleCategory,
    battle,
    merchantName: merchant.merchant_name,
  });
};
